import {Component, OnInit} from '@angular/core';
import {NewsService} from '../../../service/news.service';
import {ActivatedRoute} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {filter} from 'rxjs/operators';
import {INewsContent} from '../../../models/news.model';
import {Title} from '@angular/platform-browser';
import {IPhotoContent} from '../../../models/photo.model';
import {dialogDataComponent} from '../../modules/dialogData/dialogData.component';
import {MatDialog} from '@angular/material/dialog';


@Component({
  selector: 'app-newscontent',
  templateUrl: './newscontent.component.html',
  styleUrls: ['./newscontent.component.scss']
})
export class NewscontentComponent implements OnInit {
  INewsContent: INewsContent[] = [];
  IPhotoItem: IPhotoContent[] = [];
    name: string;
    color: string;


    constructor(
    private APINewsService: NewsService,
    private route: ActivatedRoute,
    private titleService: Title,
    private getImageService: NewsService,
    public dialog: MatDialog
  ) {
    this.titleService.setTitle('Alexander Koenig');
  }

  ngOnInit() {
    this.APINewsService.newsData().subscribe(data => {
      data = data.filter((d) => d.category === this.route.url['_value'][1]['path']);

      const filteredArr = data.reduce((acc, current) => {
        const x = acc.find(item => item.subcategory === current.subcategory);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
      this.INewsContent = filteredArr;
    });

      this.APINewsService.getImages().subscribe(items => {
          items =  items.filter((d) => d.category === this.route.url['_value'][1]['path']);
          items.forEach(item => {
            this.IPhotoItem.push(item);
          },
          (error) => {
              throw error;
          });


      });
  }

    openDialog(event): void {
      console.log(event.imageLg)
        const dialogRef = this.dialog.open(dialogDataComponent, {
            panelClass: 'dialog-wrapper',
            data: {
                name: event.name,
                image: event.imageLg,
                alt: event.alt,
                imageLg: event.imageLg
            }
        });

        dialogRef.afterClosed().subscribe(res => {
            this.color = res;
        });
    }
}
